<order-past-desktop *ngIf="!isMobile"></order-past-desktop>
<order-past-mobile *ngIf="isMobile"></order-past-mobile>